module.exports = __webpack_public_path__ + "img/p-logo.1fda50da.png";